const ka = {
  // Legacy aliases
  add: 'დამატება', edit: 'რედაქტირება', save: 'შენახვა', cancel: 'გაუქმება', delete: 'წაშლა',
  search: 'ძებნა', export: 'ექსპორტი', download: 'ჩამოტვირთვა', signIn: 'შესვლა',
  chassis: 'შასი', make: 'მწარმოებელი', model: 'მოდელი', year: 'წელი', color: 'ფერი',
  mileage: 'გარბენი', displacement: 'ძრავის მოცულობა', transmission: 'გადაცემათა კოლოფი',
  port: 'პორტი', status: 'სტატუსი', price: 'ფასი', cost: 'ღირებულება', fobPrice: 'FOB ფასი',
  condition: 'მდგომარეობა', quantity: 'რაოდენობა', category: 'კატეგორია', fitment: 'თავსებადობა',
  cutType: 'ჭრის ტიპი', sku: 'SKU', name: 'სახელი', email: 'ელ. ფოსტა', password: 'პაროლი',
  phone: 'ტელეფონი', company: 'კომპანია', country: 'ქვეყანა', scan: 'QR სკანირება',
  priceQuotes: 'ფასის შეთავაზებები', selectionOrders: 'შერჩევის ბრძანებები', pricing: 'ფასები',
  vehicles: 'ავტომობილები', engines: 'ძრავები', parts: 'ნაწილები', containers: 'კონტეინერები',
  customers: 'მომხმარებლები', requests: 'მოთხოვნები', employees: 'თანამშრომლები', settings: 'პარამეტრები',
  dashboard: 'მთავარი პანელი', inventory: 'ინვენტარი', myStock: 'ჩემი მარაგი',
  invoices: 'ინვოისები', payments: 'გადახდები', noData: 'მონაცემები არ არის',
  loading: 'იტვირთება...', totalUnits: 'სულ ერთეული', printQR: 'QR ბეჭდვა',
  whatsAppInquiry: 'WhatsApp შეკითხვა', viewDetails: 'დეტალები',
  staffPortal: 'თანამშრომლის პორტალი', customerPortal: 'მომხმარებლის პორტალი',
  invalidCredentials: 'არასწორი მონაცემები',
  recentActivity: 'ბოლო აქტივობა', inventoryValue: 'ინვენტარის ღირებულება',
  inTransit: 'ტრანზიტში', pendingRequests: 'მოლოდინში მოთხოვნები',

  // Dashboard
  dash_welcome: 'მოგესალმებით, {name}',
  dash_good_morning: 'დილა მშვიდობისა', dash_good_afternoon: 'შუადღე მშვიდობისა', dash_good_evening: 'საღამო მშვიდობისა',
  dash_financial_overview: 'ფინანსური მიმოხილვა',
  dash_units_in_account: 'ერთეული თქვენს ანგარიშზე',
  dash_my_shipments: 'ჩემი გზავნილები', dash_on_the_way: 'გზაში', dash_arrived: 'ჩამოვიდა',
  dash_no_shipments: 'აქტიური გზავნილები არ არის',
  dash_recommended: 'რეკომენდებული თქვენთვის', dash_available_units: 'ხელმისაწვდომი ერთეულები',
  dash_no_available: 'ხელმისაწვდომი ერთეულები არ არის.',
  dash_total_fob: 'სულ FOB ღირებულება', dash_total_cost: 'სულ თვითღირებულება',
  dash_late_night: 'ღამე მშვიდობისა', dash_hello: 'გამარჯობა',
  dash_subtitle: 'თქვენი ავტოპარკის, ნაწილებისა და შემომავალი გზავნილების მიმოხილვა — რეალურ დროში.',
  dash_local_time: 'ადგილობრივი დრო', dash_status: 'სტატუსი', dash_all_systems_live: 'ყველა სისტემა მუშაობს',
  dash_view_recommendations: 'რეკომენდაციების ნახვა', dash_my_stock: 'ჩემი მარაგი', dash_in_transit: 'გზაში',
  dash_units: 'ერთეული', dash_containers: 'კონტეინერი', dash_browse_more: 'მეტის ნახვა',
  dash_track_shipments: 'გზავნილების თვალყურის დევნება', dash_browse_inventory_start: 'დაათვალიერეთ კატალოგი დასაწყებად',
  dash_no_active_shipments: 'აქტიური გზავნილები არ არის', dash_next_eta: 'შემდეგი ჩამოსვლა', dash_days: 'დღე',
  dash_etas_confirming: 'ჩამოსვლის თარიღები დგინდება', dash_this_week: 'ამ კვირაში',
  dash_arriving_soon: 'მალე ჩამოვა', dash_logistics: 'ლოჯისტიკა', dash_active_shipments: 'აქტიური გზავნილები',
  dash_view_all: 'ყველას ნახვა', dash_shipment_empty: 'თქვენი შემდეგი გზავნილი აქ გამოჩნდება, როცა ერთეულები კონტეინერში ჩაიტვირთება',
  dash_composition: 'შემადგენლობა', dash_stock_breakdown: 'მარაგის სტრუქტურა', dash_no_units_yet: 'ჯერ ერთეულები არ არის',
  dash_browse_to_build: 'დაათვალიერეთ კატალოგი მარაგის შესაქმნელად',
  dash_for_you: 'თქვენთვის', dash_picked_based: 'შერჩეულია თქვენი მარაგის მიხედვით', dash_browse_all: 'ყველას დათვალიერება',
  dash_picking_units: 'ვარჩევთ ერთეულებს თქვენთვის. შეამოწმეთ მოგვიანებით ან დაათვალიერეთ სრული კატალოგი',
  dash_view_details: 'დეტალების ნახვა', dash_just_arrived: 'ახლახან ჩამოვიდა', dash_similar: 'მსგავსი თქვენსას',
  dash_today: 'დღეს', dash_tomorrow: 'ხვალ',
  dash_gross_margin: 'მთლიანი მარჟა', dash_awaiting_pricing: 'ფასდადებას ელოდება',
  dash_vehicle_fob: 'ავტომობილების FOB', dash_engine_fob: 'ძრავების FOB',
  dash_parts_fob: 'ნაწილების FOB', dash_total_freight: 'სულ ფრახტის ღირებულება',
  dash_fob_by_make: 'FOB მწარმოებლის მიხედვით', dash_no_priced_vehicles: 'შეფასებული ავტომობილები არ არის',
  dash_top_units: 'ტოპ-5 ერთეული FOB-ით', dash_no_priced_units: 'შეფასებული ერთეულები არ არის',
  dash_margin: 'მარჟა', dash_container_breakdown: 'კონტეინერების ფინანსური ანალიზი',
  dash_no_containers: 'კონტეინერები არ არის',
  dash_container: 'კონტეინერი', dash_route: 'მარშრუტი', dash_units: 'ერთეულები',
  dash_freight_cost: 'ფრახტის ღირებულება', dash_fob_value: 'FOB ღირებულება',
  dash_net_after_freight: 'წმინდა ფრახტის შემდეგ',
  dash_receivables: 'მისაღები თანხები', dash_total: 'სულ', dash_current: 'მიმდინარე',
  dash_overdue: 'ვადაგადაცილებული', dash_oldest: 'უძველესი', dash_days: 'დღე',
  dash_this_month: 'ამ თვეში', dash_invoiced: 'ინვოისირებული', dash_received: 'მიღებული',
  dash_avg_margin: 'საშუალო მარჟა', dash_quotes_sent: 'გაგზავნილი შეთავაზებები',
  dash_pending_actions: 'მოლოდინში მოქმედებები', dash_receipts_verify: 'ქვითარი საჭიროებს შემოწმებას',
  dash_units_pricing: 'ერთეული საჭიროებს ფასდადებას', dash_invoices_overdue: 'ვადაგადაცილებული ინვოისი',
  dash_customer_balances: 'მომხმარებლის ბალანსები', dash_customer_overview: 'მომხმარებლის მიმოხილვა',
  dash_top_customers: 'საუკეთესო მომხმარებლები (შემოსავლით)',
  dash_attention: 'ყურადღება', dash_no_customer_data: 'მომხმარებლის მონაცემები არ არის.',
  dash_no_customers: 'მომხმარებლები არ არის', dash_no_activity: 'ბოლო აქტივობა არ არის',
  dash_price_quotes: 'ფასის შეთავაზებები', dash_pending: 'მოლოდინში',
  dash_in_progress: 'მიმდინარე', dash_quoted_week: 'შეფასებული ამ კვირაში',
  dash_total_units: 'სულ ერთეული',

  // Navigation
  nav_dashboard: 'მთავარი პანელი', nav_inventory: 'ინვენტარი', nav_my_stock: 'ჩემი მარაგი',
  nav_my_selection: 'ჩემი არჩევანი', nav_containers: 'კონტეინერები', nav_requests: 'მოთხოვნები',
  nav_invoices: 'ინვოისები', nav_payments: 'გადახდები', nav_customers: 'მომხმარებლები',
  nav_employees: 'თანამშრომლები', nav_settings: 'პარამეტრები', nav_pricing: 'ფასები',
  nav_price_quotes: 'ფასის შეთავაზებები', nav_selection_orders: 'შერჩევის ბრძანებები',
  nav_tasks: 'დავალებები',
  nav_scan: 'სკანირება', nav_sign_out: 'გასვლა',

  // Buttons
  btn_save: 'შენახვა', btn_cancel: 'გაუქმება', btn_delete: 'წაშლა', btn_edit: 'რედაქტირება',
  btn_add: 'დამატება', btn_submit: 'გაგზავნა', btn_approve: 'დამტკიცება', btn_reject: 'უარყოფა',
  btn_download: 'ჩამოტვირთვა', btn_upload: 'ატვირთვა', btn_search: 'ძებნა', btn_export: 'ექსპორტი',
  btn_clear: 'გასუფთავება', btn_confirm: 'დადასტურება', btn_close: 'დახურვა', btn_view: 'ნახვა',
  btn_remove: 'წაშლა', btn_back: 'უკან', btn_next: 'შემდეგი',
  btn_save_changes: 'ცვლილებების შენახვა', btn_sign_in: 'შესვლა', btn_contact_us: 'კონტაქტი',

  // Login
  login_title: 'BIG STAR', login_subtitle: 'ავტომობილების ექსპორტის მართვა',
  login_staff_portal: 'თანამშრომლის პორტალი', login_customer_portal: 'მომხმარებლის პორტალი',
  login_username: 'მომხმარებლის სახელი', login_email: 'ელ. ფოსტა', login_password: 'პაროლი',
  login_remember: 'დამიმახსოვრე', login_invalid: 'არასწორი მონაცემები',
  login_timeout: 'სესია ამოიწურა. შედით თავიდან.',

  // Inventory
  inv_add_to_stock: 'ჩემს მარაგში დამატება', inv_in_stock: 'ჩემს მარაგში',
  inv_sold: 'გაყიდული', inv_available: 'ხელმისაწვდომი',
  inv_search_placeholder: 'ძებნა ავტომობილები, ნაწილები, ძრავები...',
  inv_no_results: 'ვერაფერი მოიძებნა', inv_vehicles: 'ავტომობილები', inv_engines: 'ძრავები',
  inv_parts: 'ნაწილები', inv_all: 'ყველა', inv_no_data: 'მონაცემები არ არის',
  inv_all_items: 'ყველა ელემენტი', inv_all_status: 'ყველა სტატუსი', inv_all_makes: 'ყველა მწარმოებელი',
  inv_all_years: 'ყველა წელი', inv_all_transmissions: 'ყველა გადაცემათა კოლოფი',
  inv_all_conditions: 'ყველა მდგომარეობა', inv_all_categories: 'ყველა კატეგორია',
  inv_all_countries: 'ყველა ქვეყანა', inv_item: 'ელემენტი', inv_details: 'დეტალები',
  inv_days: 'დღეები', inv_show: 'ჩვენება', inv_request_parts: 'ნაწილების მოთხოვნა',
  inv_how_want_vehicle: 'როგორ გსურთ ეს ავტომობილი?',
  inv_full_vehicle: 'სრული ავტომობილი', inv_full_vehicle_desc: 'სრულად როგორც არის',
  inv_custom: 'მორგებული', inv_custom_desc: 'აღწერეთ თქვენი მოთხოვნა',

  // Detail labels
  detail_make: 'მწარმოებელი', detail_model: 'მოდელი', detail_year: 'წელი', detail_chassis: 'შასი',
  detail_color: 'ფერი', detail_mileage: 'გარბენი', detail_grade: 'კლასი', detail_score: 'შეფასება',
  detail_engine_code: 'ძრავის კოდი', detail_transmission: 'გადაცემათა კოლოფი',
  detail_fuel: 'საწვავის ტიპი', detail_steering: 'საჭე', detail_drive: 'წამყვანი სისტემა',
  detail_condition: 'მდგომარეობა', detail_status: 'სტატუსი', detail_price: 'ფასი',
  detail_fob: 'FOB ფასი', detail_displacement: 'ძრავის მოცულობა',
  detail_port: 'პორტი', detail_city: 'ქალაქი', detail_seats: 'ადგილები',
  detail_category: 'კატეგორია', detail_fitment: 'თავსებადობა', detail_quantity: 'რაოდენობა',
  detail_sku: 'SKU', detail_cut_type: 'ჭრის ტიპი', detail_photos: 'ფოტოები',
  detail_notes: 'შენიშვნები', detail_location: 'ადგილმდებარეობა', detail_manufacturer: 'მწარმოებელი',
  detail_assign_customer: 'მომხმარებლის მინიჭება', detail_assigned_to: 'მინიჭებული',
  detail_request_parts: 'ნაწილების მოთხოვნა ამ ავტომობილიდან',

  // Statuses
  status_available: 'ხელმისაწვდომი', status_assigned: 'მინიჭებული', status_sold: 'გაყიდული',
  status_shipped: 'გაგზავნილი', status_in_transit: 'ტრანზიტში', status_at_port: 'პორტში',
  status_customs: 'საბაჟო', status_delivered: 'მიტანილი', status_japan_yard: 'იაპონიის მოედანი',
  status_loading: 'დატვირთვა', status_loaded: 'დატვირთული', status_pending: 'მოლოდინში',
  status_approved: 'დამტკიცებული', status_rejected: 'უარყოფილი', status_planning: 'დაგეგმვა',
  status_booked: 'დაჯავშნილი', status_sealed: 'დალუქული', status_closed: 'დახურული',

  // Stock
  stock_title: 'ჩემი მარაგი', stock_available_section: 'ხელმისაწვდომი ერთეულები',
  stock_in_review: 'განხილვაშია', stock_approved_section: 'დამტკიცებული',
  stock_empty: 'თქვენი მარაგი ცარიელია.', stock_request_quote: 'ფასის მოთხოვნა',
  stock_quote_requested: 'ფასი მოთხოვნილია', stock_my_orders: 'ჩემი შეკვეთები',

  // Selection
  sel_units_selected: '{count} ერთეული შერჩეული', sel_submit: 'საბოლოო არჩევანის გაგზავნა',
  sel_review_title: 'გადახედეთ თქვენს არჩევანს',

  // Containers
  cont_title: 'კონტეინერები', cont_no_containers: 'კონტეინერები ჯერ არ არის.',
  cont_destination: 'დანიშნულება', cont_eta: 'მოსვლის სავარაუდო დრო', cont_seal: 'ლუქის ნომერი',
  cont_download_bl: 'კონოსამენტის ჩამოტვირთვა', cont_arrived: 'კონტეინერი ჩამოვიდა',
  cont_new_container: 'ახალი კონტეინერი',

  // Invoices
  invoice_title: 'ინვოისები', invoice_action_required: 'მოქმედება საჭიროა',
  invoice_total_invoiced: 'ინვოისირებული', invoice_total_paid: 'გადახდილი',
  invoice_outstanding: 'გადასახდელი', invoice_overdue: 'ვადაგადაცილებული',
  invoice_upload_receipt: 'ქვითრის ატვირთვა', invoice_download_pdf: 'PDF ჩამოტვირთვა',
  invoice_no_invoices: 'ინვოისები არ არის', invoice_empty_msg: 'ინვოისები აქ გამოჩნდება შექმნისას.',

  // Payments
  pay_title: 'გადახდები', pay_verified: 'შემოწმებული გადახდები',
  pay_no_verified: 'შემოწმებული გადახდები ჯერ არ არის.',
  pay_add: 'გადახდის დამატება', pay_outgoing: 'გამავალი გადახდები',
  pay_no_outgoing: 'გამავალი გადახდები არ არის ფიქსირებული.',
  pay_verify: 'შემოწმება', pay_reject: 'უარყოფა',

  // Selection Orders
  selorder_title: 'შერჩევის ბრძანებები', selorder_no_orders: 'შერჩევის ბრძანებები არ არის',
  selorder_empty_msg: 'მომხმარებლის შერჩევის ბრძანებები აქ გამოჩნდება წარდგენისას.',

  // Requests
  req_title: 'მოთხოვნები', req_new: 'ახალი მოთხოვნა', req_reply: 'პასუხი',

  // Settings
  settings_title: 'პარამეტრები', settings_profile: 'ჩემი პროფილი',

  // Common UI
  ui_all_customers: 'ყველა მომხმარებელი', ui_export_csv: 'CSV ექსპორტი',
  ui_edit: 'რედაქტირება', ui_delete: 'წაშლა', ui_download: 'ჩამოტვირთვა',

  // Condition
  cond_good: 'კარგი', cond_minor_damage: 'მცირე დაზიანება',
  cond_major_damage: 'მძიმე დაზიანება', cond_missing_parts: 'ნაწილები აკლია',

  // Notifications
  notif_title: 'შეტყობინებები', notif_no_new: 'ახალი შეტყობინებები არ არის',

  // Misc
  misc_all_customers: 'ყველა მომხმარებელი', misc_no_data: 'მონაცემები არ არის',
  misc_loading: 'იტვირთება...', misc_country: 'ქვეყანა', misc_currency: 'ვალუტა',
};
export default ka;
